import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { ChevronRight, Left } from '../../../components/Icon';
import { Loader } from '../../../components/Loader';
import { PageHeader } from '../../../components/PageHeader';
import { selectWorks } from '../../Api/selectors';
import { fetchWorkflow } from '../actions';
import { REQUEST_WORKFLOW } from '../constants';
import { selectWorkflow } from '../selectors';

import { WorkflowDetailsColumns } from './WorkflowDetailsColumns';
import { HBox } from '../../../components/Box';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
const Container = styled.div`
  color: #6e6e6e;
  font-weight: 400;

  .content {
  }
`;

/* eslint-disable react/prefer-stateless-function */
class WorkflowDetailsDetails extends BaseComponent {
  constructor(props) {
    super(props, {});
    this.goBack = this.goBack.bind(this);
  }

  componentDidMount() {
    if (this.props.workflow_id) this.props.fetch();
  }

  goBack(event) {
    window.history.go(-1);
  }

  get workflow() {
    return this.props.workflow;
  }

  render() {
    if (!this.workflow && this.props.workflow_id) return <Loader small />;

    const back_url = this.props.history.location.pathname.slice(0, this.props.history.location.pathname.lastIndexOf('/'));

    return (
      <div className="container-fluid p-0">
        <PageHeader
          title={this.props.workflow_id ? this.lbl('workflows.details.title') : this.lbl('workflows.create.title')}
          breadCrumbs={
            <HBox vCenter>
              <span className="nav-link" onClick={() => this.to('/')}>
                Vindat
              </span>
              <ChevronRight />
              <span className="nav-link" onClick={() => this.to('/workflows')}>
                {this.lbl('leftBar.workflows')}
              </span>

              <ChevronRight />
              <span className="nav-link active" onClick={() => this.to('/workflows/new')}>
                {this.props.workflow_id ? this.lbl('workflows.details.title') : this.lbl('workflows.create.title')}
              </span>
            </HBox>
          }
        ></PageHeader>

        <>
          <Switch>
            <Route
              render={component => (
                <WorkflowDetailsColumns
                  key={this.props.workflow?.id}
                  workflow={this.workflow}
                  workflow_id={this.workflow?.id}
                />
              )}
            />
          </Switch>
        </>
      </div>
    );
  }
}

WorkflowDetailsDetails.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    workflow: selectWorkflow(ownProps.workflow_id),
    work: selectWorks([REQUEST_WORKFLOW]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchWorkflow(ownProps.workflow_id));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WorkflowDetails = compose(withConnect, withRouter)(WorkflowDetailsDetails);
